import { useAppStore } from '../../state/appStore';
import { useT } from '../hooks';
import { BigButton, Panel, ScreenShell } from '../components';

const ROWS = [
  'throttle',
  'brake',
  'clutch',
  'clutchFeed',
  'steer',
  'gearsManual',
  'gearsSeq',
  'gears',
  'ignition',
  'handbrake',
  'signals',
  'glance',
  'lights',
  'horn',
  'belt',
  'camera',
  'pause',
] as const;

export function ControlsScreen() {
  const t = useT();
  const setScreen = useAppStore((s) => s.setScreen);
  return (
    <ScreenShell>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <h2 className="min-w-0 flex-1 break-words text-2xl font-bold sm:text-3xl">{t('controls.title')}</h2>
        <BigButton className="shrink-0" variant="ghost" onClick={() => setScreen('menu')}>
          ← {t('settings.back')}
        </BigButton>
      </div>
      <Panel className="overflow-x-auto overscroll-x-contain">
        <table className="w-full min-w-[640px] text-sm">
          <thead className="bg-white/5 text-left text-white/60">
            <tr>
              <th className="px-4 py-3" />
              <th className="px-4 py-3">⌨️ {t('controls.keyboard')}</th>
              <th className="px-4 py-3">🎮 {t('controls.gamepad')}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {ROWS.map((row) => (
              <tr key={row}>
                <td className="px-4 py-2.5 font-medium text-white/85">{t(`controls.${row}`)}</td>
                <td className="px-4 py-2.5 text-sky-300">{t(`controls.kb.${row}`)}</td>
                <td className="px-4 py-2.5 text-emerald-300">{t(`controls.gp.${row}`)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Panel>
      <Panel className="px-5 py-4">
        <div className="mb-1 font-semibold text-amber-300">🦵 {t('controls.clutchTip.title')}</div>
        <p className="text-sm leading-relaxed text-white/70">{t('controls.clutchTip.body')}</p>
      </Panel>
      <p className="text-sm text-white/50">🛞 {t('controls.wheel')}</p>
    </ScreenShell>
  );
}
